// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Box, Modal } from '@mui/material';
import { ManageTags, type ManageTagsProps } from './manage-tags';

export interface ManageTagsModalProps extends ManageTagsProps {
  openModal: boolean;
}

export const ManageTagsModal = ({ openModal, ...props }: ManageTagsModalProps) => {
  return (
    <Modal open={openModal} className="overflow-y-scroll" data-testid="tags-modal">
      <Box className="fixed inset-0 flex items-center justify-center bg-transparent">
        <Box className="relative h-full max-h-[90vh] w-[1104px] overflow-y-auto rounded-lg bg-white px-4 py-0">
          <div className="px-6 py-10">
            <ManageTags {...props} />
          </div>
        </Box>
      </Box>
    </Modal>
  );
};
